export enum OrganizationLevel {
    /**
     * 部门
     */
    DEPARTMENT = 'DEPARTMENT',
    /**
     * 单位
     */
    UNIT = 'UNIT',
    /**
     * 表单上的变量单位
     */
    EXPRESSION = 'EXPRESSION',
    /**
     * 默认
     */
    DEFAULT = 'DEFAULT'
}